'use client'

import * as React from 'react'

import type { Locale } from './config'
import { createTranslator, type Translate } from './translate'

const Context = React.createContext<{ locale: Locale; t: Translate } | null>(null)

export function I18nProvider({ locale, children }: { locale: Locale; children: React.ReactNode }) {
  const value = React.useMemo(() => ({ locale, t: createTranslator(locale) }), [locale])
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export function useT() {
  const context = React.useContext(Context)
  if (!context) throw new Error('useT must be used inside <I18nProvider>')
  return context
}
